import { Padding } from "@mui/icons-material";

export const navbarStyles = {
    drawer: {
        flexShrink: 0,
        '& .MuiDrawer-paper': {
            boxSizing: 'border-box',
            backgroundColor: '#191F2B',
            color: 'rgba(255, 255, 255, 0.7)',
        },
        '& .Mui-selected': {
            color: 'red',
        },
    },
    icons: {
        marginLeft: '20px',
        color: '#FFFFFF',
    },
    list: {
        '&:hover': {
            width: '100%',
            backgroundColor: '#432F60',
            background: `linear-gradient(to right, #9E3C5D, #432F60)`,
            color: '#FFFFFF',
            '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
                color: '#FFFFFF',
            },
        },
        '& span': {
            color: '#FFFFFF'
        },
    },
    text: {
        
        '& span': {
            marginLeft: '-10px',
            fontWeight: '600',
            fontSize: '16px',
        }
    }
};